import React from 'react';

export const JcbIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1437_44457)">
        <path
          d="M21.75 0.25H2.25C1.14543 0.25 0.25 1.14543 0.25 2.25V13.75C0.25 14.8546 1.14543 15.75 2.25 15.75H21.75C22.8546 15.75 23.75 14.8546 23.75 13.75V2.25C23.75 1.14543 22.8546 0.25 21.75 0.25Z"
          fill="white"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.5"
        />
        <path
          d="M19.4542 11.4237C19.4542 12.7042 18.4164 13.7425 17.1355 13.7425H4.54688V4.57692C4.54688 3.29612 5.58472 2.25781 6.86577 2.25781H19.4541L19.454 11.4237L19.4542 11.4237Z"
          fill="white"
        />
        <path
          d="M15.3503 8.20091C15.7098 8.20872 16.0714 8.18503 16.4296 8.21322C16.7922 8.28088 16.8797 8.82992 16.5574 9.00974C16.3376 9.1282 16.0764 9.05386 15.8381 9.07475H15.3503V8.20091ZM16.6375 7.21183C16.7173 7.4938 16.4455 7.74697 16.174 7.70814H15.3503C15.3561 7.44223 15.339 7.15362 15.3586 6.90171C15.6886 6.911 16.0216 6.88276 16.3497 6.91648C16.4906 6.95189 16.6086 7.06777 16.6375 7.21183ZM18.6198 3.03029C18.6351 3.56879 18.622 4.13574 18.6264 4.68515C18.6254 6.91888 18.6285 9.15254 18.6246 11.3864C18.6102 12.2235 17.8683 12.9509 17.0369 12.9676C16.2048 12.971 15.3725 12.9682 14.5402 12.9691V9.59217C15.447 9.58749 16.3543 9.60168 17.2607 9.58509C17.6812 9.55869 18.1418 9.28125 18.1613 8.81851C18.2109 8.35377 17.7727 8.03232 17.3567 7.98155C17.1968 7.9774 17.2015 7.93494 17.3567 7.91642C17.7535 7.83066 18.065 7.42002 17.9483 7.00875C17.8488 6.5762 17.3707 6.40879 16.9731 6.40962C16.1622 6.40411 15.3513 6.40885 14.5404 6.40725C14.5456 5.77682 14.5295 5.14571 14.5491 4.51574C14.6133 3.69371 15.3739 3.0158 16.1936 3.03051C17.0024 3.03039 17.8111 3.03039 18.6198 3.03035V3.03029Z"
          fill="url(#paint0_linear_1437_44457)"
        />
        <path
          d="M5.37704 4.60103C5.39774 3.76522 6.14282 3.04377 6.9731 3.03155C7.80217 3.029 8.63137 3.03118 9.46045 3.03045C9.45817 5.82691 9.46494 8.62368 9.45704 11.42C9.4251 12.2456 8.68814 12.9533 7.86691 12.968C7.03627 12.971 6.20553 12.9684 5.37485 12.9692V9.47845C6.18171 9.66906 7.02784 9.7502 7.85097 9.62377C8.34301 9.5446 8.88134 9.30297 9.04793 8.79251C9.17051 8.35586 9.1015 7.89632 9.11974 7.44817V6.4074H7.69522C7.68882 7.09574 7.70833 7.78528 7.68491 8.47278C7.64651 8.89537 7.22802 9.16386 6.82947 9.14952C6.33519 9.15475 5.35571 8.79131 5.35571 8.79131C5.35325 7.50165 5.37005 5.88654 5.37704 4.60115V4.60103Z"
          fill="url(#paint1_linear_1437_44457)"
        />
        <path
          d="M9.99208 6.82735C9.91709 6.84326 9.977 6.57194 9.95783 6.46901C9.96294 5.81824 9.94716 5.16677 9.96654 4.51646C10.0306 3.69095 10.797 3.01135 11.62 3.03068H14.0436C14.0414 5.82714 14.0481 8.62391 14.0402 11.4202C14.0083 12.2459 13.2712 12.9535 12.45 12.9682C11.6193 12.9713 10.7885 12.9687 9.9578 12.9695V9.14486C10.5252 9.61037 11.2963 9.68283 12.0031 9.68409C12.536 9.68391 13.0657 9.60175 13.5832 9.47886V8.77818C13 9.06883 12.3145 9.25345 11.668 9.08646C11.2171 8.97421 10.8897 8.5384 10.897 8.07301C10.8448 7.58905 11.1284 7.07809 11.604 6.93421C12.1945 6.74935 12.8381 6.89074 13.3916 7.13108C13.5102 7.19317 13.6306 7.27018 13.5832 7.07197V6.52123C12.6574 6.30098 11.6723 6.21994 10.7422 6.45954C10.473 6.53548 10.2108 6.65065 9.99208 6.82741V6.82735Z"
          fill="url(#paint2_linear_1437_44457)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1437_44457"
          x1="14.5123"
          y1="7.78719"
          x2="18.6006"
          y2="7.78719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007B40" />
          <stop offset="1" stopColor="#55B330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1437_44457"
          x1="5.28793"
          y1="8.09501"
          x2="9.39346"
          y2="8.09501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2970" />
          <stop offset="1" stopColor="#006DBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1437_44457"
          x1="9.95181"
          y1="7.88385"
          x2="14.0429"
          y2="7.88385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E2B2F" />
          <stop offset="1" stopColor="#E30138" />
        </linearGradient>
        <clipPath id="clip0_1437_44457">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
